
  import {Component, Vue} from "vue-property-decorator";
  import {login, userInfo} from "@/services/api"
  import store from "@/store";

  @Component({
  })
  export default class Login extends Vue {
    // 登录表单
    public formData = {
      userName: '',
      password: ''
    }

    /**
     * 登录接口调用
     */
    login(): void {
      login(this.formData, true).then(async res => {
        if (res.data && res.data.status === 'OK') {
          const authorityList: string[] = res.data.result.authorities.map((item: {authority: string}) => item.authority);
          store.commit('SET_AUTHORITY', authorityList);
          localStorage.setItem("authorityList", JSON.stringify(authorityList));
          let defaultPath = '/edit/list'
          if (authorityList.indexOf('ROLE_投手') !== -1) {
            defaultPath = '/edit/list'
          } else if (authorityList.indexOf('ROLE_审核') !== -1) {
            defaultPath = '/audit'
          } else if (authorityList.indexOf('ROLE_超级管理员') !== -1) {
            defaultPath = '/domain/list'
          }
          await this.userInfo();
          const redirect: any = this.$route.query.redirect || defaultPath;
          this.$router.replace(redirect);
        } else {
          this.$message.error(res.data.body.message);
        }
      }).catch(() => {})
    }

    /**
     * 获取登录用户信息
     */
    async userInfo() {
      const res = await userInfo({}, true);
      if (res.data && res.data.status === 'OK') {
        //更新store
        store.commit('SET_USERDATA', res.data.result);
        localStorage.setItem("userData", JSON.stringify(res.data.result));
      }
    }

    /**
     * todo 表单检查
     */
    checkForm() {

    }
  }

